import { fontSizeMap, fontWeightMap, sizeMap, borderRadiusMap, selectedBorderWidthMap, selectedBorderRadiusMap } from './size.mjs';
import { Svg36Userplaceholder } from '@moim/icons';
import { CommonBadge } from '../alertBadge/index.mjs';
import { px2rem } from '../../helpers/rem.mjs';
import styled, { css } from 'styled-components';

var Content = styled.span.withConfig({
  displayName: "Content",
  componentId: "sc-sibfgn-0"
})(["display:flex;width:100%;height:100%;align-items:center;justify-content:center;overflow:hidden;color:#ffffff;"]);
var ImageStyle = css(["object-fit:cover;width:100%;height:100%;"]);
var Image = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-sibfgn-1"
})(["", ""], ImageStyle);
var DefaultImage = styled(Svg36Userplaceholder).withConfig({
  displayName: "DefaultImage",
  componentId: "sc-sibfgn-2"
})(["", ""], ImageStyle);
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-sibfgn-3"
})(["display:block;position:relative;font-size:", ";font-weight:", ";width:", ";height:", ";border-radius:", ";user-select:none;", "{border-radius:", ";}transition:padding 170ms ease-in-out;", " ", ";"], function (props) {
  return px2rem(fontSizeMap.get(props.size));
}, function (props) {
  var _a;
  return (_a = fontWeightMap.get(props.size)) === null || _a === void 0 ? void 0 : _a(props.theme);
}, function (props) {
  return px2rem(sizeMap.get(props.size));
}, function (props) {
  return px2rem(sizeMap.get(props.size));
}, function (props) {
  return px2rem(borderRadiusMap.get(props.size));
}, Content, function (props) {
  return px2rem(borderRadiusMap.get(props.size));
}, function (props) {
  return (props.selected || props.hovered) && css(["box-shadow:inset 0 0 0 ", " ", ",inset 0 0 0 ", " ", ";padding:", ";", "{border-radius:", ";", ",", "{overflow:hidden;border-radius:", ";}}"], px2rem(selectedBorderWidthMap.get(props.size)), props.selected ? props.theme.colorV2.colorSet.grey600 : props.theme.colorV2.colorSet.grey50, px2rem(selectedBorderWidthMap.get(props.size) * 2), props.theme.colorV2.colorSet.white1000, px2rem(3), Content, px2rem(selectedBorderRadiusMap.get(props.size)), Image, DefaultImage, px2rem(selectedBorderRadiusMap.get(props.size)));
}, function (props) {
  return props.styles;
});
var LabelWrapper = Wrapper.withComponent("label");
var Badge = styled(CommonBadge).withConfig({
  displayName: "Badge",
  componentId: "sc-sibfgn-4"
})(["position:absolute;right:", ";bottom:", ";z-index:", ";"], px2rem(-3), px2rem(-3), function (props) {
  return props.theme.zIndexes["default"];
});
var UnreadBadge = styled.div.withConfig({
  displayName: "UnreadBadge",
  componentId: "sc-sibfgn-5"
})(["position:absolute;right:", ";bottom:", ";width:", ";height:", ";z-index:", ";border-radius:50%;"], px2rem(-4), px2rem(-4), px2rem(5), px2rem(5), function (props) {
  return props.theme.zIndexes["default"];
});
var NewNotificationBadge = styled(UnreadBadge).withConfig({
  displayName: "NewNotificationBadge",
  componentId: "sc-sibfgn-6"
})(["background-color:", ";"], function (props) {
  return props.theme.colorV2.accent;
});
var NewContentsBadge = styled(UnreadBadge).withConfig({
  displayName: "NewContentsBadge",
  componentId: "sc-sibfgn-7"
})(["background-color:", ";"], function (props) {
  return props.theme.colorV2.colorSet.grey600;
});

export { Badge, Content, DefaultImage, Image, LabelWrapper, NewContentsBadge, NewNotificationBadge, UnreadBadge, Wrapper };
